export default __webpack_public_path__ + "0fd19519dd7e867372574836eab54151.png";